import { useQuery } from '@tanstack/react-query';
import { getClinicUser } from '@/services/admin/clinicUsers';

/**
 * Query hook to fetch a clinic user by ID (admin portal).
 */
export const useClinicUserQuery = (siteType: string, id: number | null) => {
  return useQuery({
    queryKey: ['admin', 'clinic-users', siteType, id],
    queryFn: () => getClinicUser(siteType, id!),
    enabled: !!siteType && id !== null && id > 0,
  });
};
